import Language from "./Language";
import Requirements from "./Requirements";
import Auth from "./Auth";
import SocketIO from "./SocketIO";
import Settings from "./Settings";
import Forms from "./Forms";
import Document from "./Document";
import Product from "./Product";
import ProductCategory from "./ProductCategory";
import ShoppingCart from "./ShoppingCart";
import Order from "./Order";
import PaymentNotification from "./PaymentNotification";
import Currency from "./Currency";
import AccountNumber from "./AccountNumber";
import PaymentType from "./PaymentType";

const exportHelpers = {
    ...Language,
    ...Requirements,
    ...Auth,
    ...SocketIO,
    ...Settings,
    ...Forms,
    ...Document,
    ...Product,
    ...ProductCategory,
    ...ShoppingCart,
    ...Order,
    ...PaymentNotification,
    ...Currency,
    ...AccountNumber,
    ...PaymentType
}

export default exportHelpers;